import { sendPost } from './axios';

export const searchUser = (payload) => sendPost(`/user/search-profile?pageIndex=1&pageSize=1000&standBy=${payload?.standBy}`, payload);

export const searchUserTrial = async(payload) =>{
  try{
    let data = await sendPost(`/user/search-profile-trial?pageIndex=1&pageSize=1000`, payload);
    return data
  } catch(error) {
    return {data: [], messageErr:  error.response.data.message}
  }

}

export const searchAgent = (payload) => sendPost(`/agent/search-profile?pageIndex=1&pageSize=1000`, payload);

export const searchJob = async(payload) => {
  try{
    let data = await sendPost(`/job/search-job?pageIndex=1&pageSize=1000`, payload);
    return data
  } catch(error) {
    return {data: [], messageErr:  error.response.data.message}
  }
}
